var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"token",class:_vm.name,on:{"click":function($event){return _vm.$emit('click', _vm.name)}}},[_c('img',{staticClass:"token--image",attrs:{"src":_vm.src,"alt":_vm.name}})])}
var staticRenderFns = []

export { render, staticRenderFns }